/**
 * `/traffic/profiles` — moved to `/performance/segments`.
 *
 * Segments report Core Web Vitals per audience, which is Performance's
 * question, not Traffic's. The route stays as a redirect because it
 * shipped in the nav and will be sitting in bookmarks and shared links.
 * It targets the final path directly (not the `/performance/profiles`
 * redirect it used to point at) so an old link takes one hop.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/traffic/profiles')({
  beforeLoad: () => {
    throw redirect({ to: '/performance/segments' });
  },
});
